import { css } from '@emotion/react';
import { type ReactNode } from 'react';
import {
  ButtonSize,
  ButtonStyle, ButtonStyles, getButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { useTheme } from '~/_shared/themes/theme.hooks';

type ButtonLinkProps = Readonly<{
  className?: string;
  href?: string;
  children?: ReactNode;
  buttonStyle?: ButtonStyle;
  size?: ButtonSize;
}>;

const linkNormalizeStyle = css({
  textDecoration: 'none',
});

export const ButtonLinkComponent = ({ className, buttonStyle = ButtonStyle.Primary, href, children, size = ButtonSize.Medium }: ButtonLinkProps) => {
  const theme = useTheme();
  const btnStyle = ButtonStyles(theme)[buttonStyle];

  return (
    <a
      css={[linkNormalizeStyle, getButtonStyle({
        btnStyle,
        theme,
        size: size || ButtonSize.Medium,
      })]}
      className={className}
      href={href}
    >
      {children}
    </a>
  );
};
